import { SearchProps } from '@procore/core-react/dist/_typedoc/Search/Search.types.json';
import * as React from 'react';
export default {
  SearchProps,
  React
};